import { closeSnackbar, enqueueSnackbar } from 'notistack';

export const SYNC_NOTIFICATION_KEY = 'calendar-sync';

export const enqueueLoadingSnackbar = (message) =>
  enqueueSnackbar(message, {
    variant: 'loading',
    key: SYNC_NOTIFICATION_KEY,
    persist: true,
    autoHideDuration: null
  });

export const closeLoadingSnackbar = () => closeSnackbar(SYNC_NOTIFICATION_KEY);
